export const LLM_PROVIDER_SELECT_OPTIONS = [
  { label: 'OpenAI (облако)', value: 'ChatGPT' },
];
